/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./table-group-list.vue?vue&type=template&id=4cb70c06&scoped=true&"
import script from "./table-group-list.vue?vue&type=script&lang=ts&"
export * from "./table-group-list.vue?vue&type=script&lang=ts&"
import style0 from "./table-group-list.vue?vue&type=style&index=0&id=4cb70c06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb70c06",
  null
  
)

export default component.exports